import URI from '@dw/urijs-esm/index.js';
import { isForgotPasswordPage } from './validate-url.js';

/**
 * @param {Object} data - Router data context
 * @return Promise -  If url path is /forgot-password then resolve promise with forgot password page data.
 *                    Otherwise reject a promise.
 */
export const forgotPasswordRouter = (data) => {
  return new Promise((resolve, reject) => {
    if(isForgotPasswordPage(data.path)) {
      let params = new URI().query(true);
      data.page = {
        name: 'FORGOT_PASSWORD',
        params
      };
      resolve(data);
      return;
    }
    reject(data);
  });
}
